import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "app/redux/reducers/hooks";
import { getStores } from "app/redux/actions/common";
import { getToken } from "app/services/authService";

const useStores = () => {
  const dispatch = useAppDispatch();
  const { stores } = useAppSelector(({ common }) => common);
  const [loading, setLoading] = useState(false);
  const token = getToken();

  useEffect(() => {
    if (!stores?.length && token) {
      if (loading === false) {
        setLoading(true);
        dispatch(getStores());
      }
    }
  }, [dispatch, loading]);

  return { loading, stores };
};

export default useStores;
